import React, { useEffect, useState } from "react";
import apiService from "../APIService";
import Tooltip from "@mui/material/Tooltip";

const UploadFile = (props) => {
  const [selected, setSelected] = useState("Choose File");
  const [showError, setShowError] = useState(false);
  const [sizeError, setSizeError] = useState();
  const [fileName, setFileName] = useState();
  const [path, setPath] = useState();
  const data = props.item && props.item.data && JSON.parse(props.item.data);
  const type = data.extensions;
  const maxSize = data.max_size * 1024;
  const serror = data.sizeError;

  const [selectedFile, setSelectedFile] = useState(false);

  const [isShowInputField, setIsShowInputField] = useState(false);

  const [restrictedFilesError, setRestrictedFilesError] = useState("");

  const [isRestrictedFilesError, setIsRestrictedFilesError] = useState(false);

  // const max= maxSize.toString();
  console.log("uploadprops", props, data, type, maxSize);
  let name;

  const handleChange = (e) => {
    const files1 = e.target.value.split("\\");
    name = files1[files1.length - 1];

    const file = e?.target?.files && e?.target?.files[0];

    setPath(file);
    setFileName(name);

    const fileExtension = `.${file?.name.split(".").pop()}`;

    const allowedFileExtensions = type;

    console.log(
      "allowedFileExtensions",
      allowedFileExtensions,
      fileExtension,
      !allowedFileExtensions.includes(fileExtension.toLowerCase())
    );

    if (!allowedFileExtensions.includes(fileExtension.toLowerCase())) {
      setSelectedFile(false);
      setRestrictedFilesError(
        "Invalid file type. Please upload a PDF, Word document, or JPEG image."
      );
      setIsRestrictedFilesError(true);
      setSelected(name);
      return;
    }

    const size = file.size;

    if (size > maxSize) {
      setSizeError(serror);
      setShowError(true);
      setSelectedFile(false);
    } else {
      setShowError(false);
      setSelectedFile(true);
    }
    setIsRestrictedFilesError(false);
    setRestrictedFilesError("");
    setSelected(name);
  };

  useEffect(() => {
    setFileName(name);
  }, [props.name]);

  const handleUpload = () => {
    console.log("uploadData", path);
    apiService.uploadMedia(path).then((response) => {
      let data = { key1: response.data.key1 };
      // data = JSON.stringify(data);
      props.handleClick(props.item.code, data);
      console.log("uploadresponse", response);
      setIsShowInputField(true);
      setSelectedFile(false);
    });
  };

  const style = {
    cursor: !selectedFile ? "not-allowed" : "pointer",
  };

  return (
    <>
      <p
        className="bold"
        style={{ color: "#444444", fontSize: "14px", margin: "0px" }}
      >
        Upload File
      </p>
      <div
        className={isShowInputField ? "disabled-custom-file" : "custom-file"}
      >
        <input
          type="file"
          className="custom-file-input"
          id="customFile"
          accept={type.map((i) => i)}
          onChange={handleChange}
          disabled={isShowInputField}
        />
        <label className="custom-file-label" for="customFile">
          {" "}
          {selected}{" "}
        </label>
      </div>

      <div className="form-group" style={{ marginTop: "8px" }}>
        {showError && (
          <p style={{ color: "red", fontSize: "14px" }}>{sizeError}</p>
        )}
        {isRestrictedFilesError && (
          <p style={{ color: "red", fontSize: "14px" }}>
            {restrictedFilesError}
          </p>
        )}
        <div className="btn-contr text-left">
          <Tooltip
            title={
              <span style={{ fontSize: "14px" }}>Please upload some files</span>
            }
            placement="right-start"
          >
            <a
              className={!selectedFile ? "disabled-submit-btn" : "submit-btn"}
              href="#!"
              style={{ fontSize: "15px" }}
              onClick={() => {
                handleUpload();
                props.setTextOnClick(props.item.text);
              }}
              disabled={!selectedFile}
              styles={style}
            >
              Upload
            </a>
          </Tooltip>
        </div>
        <div className="height50">&nbsp;</div>
      </div>
    </>
  );
};

export default UploadFile;
